import { ThemeCollection } from '../theme';

import THEME_YACHIYO from './yachiyo.theme.json';
import THEME_KYOKO from './kyoko.theme.json';
import THEME_MADOKA from './madoka.theme.json';
import THEME_SAYAKA from './sayaka.theme.json';
import THEME_HOMURA from './homura.theme.json';
import THEME_MAMI from './mami.theme.json';
import THEME_SANA from './sana.theme.json';
import THEME_NAGISA from './nagisa.theme.json';

export let THEMES: ThemeCollection = {
    'yachiyo':  THEME_YACHIYO,
    'やちよ':   THEME_YACHIYO,
    'kyoko':    THEME_KYOKO,
    '杏子':     THEME_KYOKO,
    'madoka':   THEME_MADOKA,
    'まどか':   THEME_MADOKA,
    'sayaka':   THEME_SAYAKA,
    'さやか':   THEME_SAYAKA,
    'homura':   THEME_HOMURA,
    'ほむら':   THEME_HOMURA,
    'mami':     THEME_MAMI,
    'マミ':     THEME_MAMI,
    'sana':     THEME_SANA,
    'さな':     THEME_SANA,
    'nagisa':   THEME_NAGISA,
    'なぎさ':   THEME_NAGISA,
};
